import React from 'react'
import authDemoRoute from './authDemoRoute'
import pagesRoute from './pagesRoute'
import { AUTH_PREFIX_PATH } from 'constants/route.constant'
import { ADMIN, USER } from 'constants/roles.constant'

export const publicRoutes = [
    ...authDemoRoute,
    {
        key: 'extension-demo-page',
        path: '/demo',
        component: React.lazy(() => import('views/extension-demo/index')),
        authority: [],
    },
    // The following line will only be included if `authenticated` is truthy

    {
        key: 'home',
        path: `/:lang/home`,
        component: React.lazy(() => import('views/pages/HomePage')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'about-us',
        path: `/:lang/about-us`,
        component: React.lazy(() => import('views/pages/aboutUs/AboutUs')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'contact',
        path: '/:lang/contactUs',
        component: React.lazy(() => import('views/pages/contactUs/ContactUs')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'gdpr',
        path: '/:lang/gdpr',
        component: React.lazy(() => import('views/pages/gdpr/Gdpr')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'referrals',
        path: '/:lang/referrals',
        component: React.lazy(() => import('views/pages/referrals/referrals')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'terms-and-conditions',
        path: '/:lang/terms-and-conditions',
        component: React.lazy(() =>
            import('views/pages/termsAndConditions/TermsAndConditions')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'privacy-policy',
        path: '/:lang/privacy-policy',
        component: React.lazy(() =>
            import('views/pages/privacyPolicy/PrivacyPolicy')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },

    {
        key: 'product-detail',
        path: '/:lang/our-products/:productId',
        component: React.lazy(() =>
            import('views/pages/HomePage/OurProducts/ProductDetails')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
    {
        key: 'product-report',
        path: '/:lang/product-report',
        component: React.lazy(() =>
            import('views/pages/HomePage/OurProducts/ProductReports/index')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
    {
        key: 'basket',
        path: '/:lang/basket',
        component: React.lazy(() => import('views/pages/Basket/index')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
    {
        key: 'thank-you',
        path: '/:lang/thank-you',
        component: React.lazy(() => import('views/pages/ThankYou/index')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
]

export const protectedRoutes = [
    {
        key: 'authentication.forgotPasswordSimple',
        path: `${AUTH_PREFIX_PATH}/:lang/forgot-password-simple`,
        component: React.lazy(() =>
            import('views/auth-demo/ForgotPassword/ForgotPasswordSimple')
        ),
        authority: [ADMIN, USER],
        // meta: {
        //     layout: 'blank',
        //     pageContainerType: 'gutterless',
        //     footer: false,
        // },
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },

    {
        key: 'authentication.resetPasswordSimple',
        path: `${AUTH_PREFIX_PATH}/:lang/reset-password-simple`,
        component: React.lazy(() =>
            import('views/auth-demo/ResetPassword/ResetPasswordSimple')
        ),
        authority: [ADMIN, USER],
        // meta: {
        //     layout: 'blank',
        //     pageContainerType: 'gutterless',
        //     footer: false,
        // },
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
    {
        key: 'home',
        path: `/:lang/home`,
        component: React.lazy(() => import('views/pages/HomePage')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'about-us',
        path: `/:lang/about-us`,
        component: React.lazy(() => import('views/pages/aboutUs/AboutUs')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'contact',
        path: '/:lang/contactUs',
        component: React.lazy(() => import('views/pages/contactUs/ContactUs')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'gdpr',
        path: '/:lang/gdpr',
        component: React.lazy(() => import('views/pages/gdpr/Gdpr')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'referrals',
        path: '/:lang/referrals',
        component: React.lazy(() => import('views/pages/referrals/referrals')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'terms-and-conditions',
        path: '/:lang/terms-and-conditions',
        component: React.lazy(() =>
            import('views/pages/termsAndConditions/TermsAndConditions')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'privacy-policy',
        path: '/:lang/privacy-policy',
        component: React.lazy(() =>
            import('views/pages/privacyPolicy/PrivacyPolicy')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },

    {
        key: 'product-detail',
        path: '/:lang/our-products/:productId',
        component: React.lazy(() =>
            import('views/pages/HomePage/OurProducts/ProductDetails')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
    {
        key: 'product-report',
        path: '/:lang/product-report',
        component: React.lazy(() =>
            import('views/pages/HomePage/OurProducts/ProductReports/index')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },

    {
        key: 'basket',
        path: '/:lang/basket',
        component: React.lazy(() => import('views/pages/Basket/index')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
    {
        key: 'product-payment',
        path: '/:lang/payment',
        component: React.lazy(() =>
            import('views/pages/HomePage/OurProducts/ProductPayment/index')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
    {
        key: 'thank-you',
        path: '/:lang/thank-you',
        component: React.lazy(() => import('views/pages/ThankYou/index')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
    {
        key: 'purchases',
        path: '/:lang/purchases',
        component: React.lazy(() =>
            import('views/pages/sales/purchases/index')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
    {
        key: 'purchase-details',
        path: '/:lang/sales/purchases/purchase-details/:id',
        component: React.lazy(() =>
            import('views/pages/sales/purchaseDetails/index')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
    ///////////
    {
        key: 'linkAccounts',
        path: '/:lang/link-account',
        component: React.lazy(() => import('views/auth/LinkAccounts/Link')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },

    {
        key: 'MyData',
        path: '/:lang/MyData',
        component: React.lazy(() => import('views/MyDataComps/MyData')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'myActivity',
        path: '/:lang/myActivity',
        component: React.lazy(() => import('views/googleDataComps/MyActivity')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },

    {
        key: 'dashboard',
        path: '/:lang/dashboard',
        component: React.lazy(() => import('views/pages/Dashboard')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'affiliates',
        path: '/:lang/affiliates',
        component: React.lazy(() =>
            import('views/pages/affiliates/Affiliates')
        ),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'gutterless',
            footer: true,
        },
    },
    {
        key: 'my-account',
        path: '/:lang/my-account/:tab',
        component: React.lazy(() => import('views/account/Settings')),
        authority: [],
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },

    ...pagesRoute,
]
